import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'g',
    { id: '_Symbols', 'data-name': 'Symbols' },
    React.createElement(
      'g',
      { id: 'Header-ATC-view-Searching' },
      React.createElement('path', {
        id: 'Fill-1',
        d: 'M18.06 10.64v1.3h5.59v5.19H8.91L11 15l-.92-.92-2.63 2.66a1.42 1.42 0 0 0-.4 1 1.39 1.39 0 0 0 .4 1l2.66 2.65.92-.92-2-2H24.3a.65.65 0 0 0 .65-.65v-6.53a.65.65 0 0 0-.65-.65z'
      })
    )
  )
));